$(document).on("click", ".Link", function () {
    var datahref = $(this).attr('data-href'); // or var clickedBtnID = this.id
    fetch(datahref, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (response) {
      response.text().then(function (content) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = content;
        if (typeof gift_product !== 'undefined' && gift_product.available) {
          var cartSubtotal = parseInt(tempElement.querySelector('#gift-product--script').dataset.subtotal);
          cartGiftUpdate(tempElement, cartSubtotal);
        } else {
          document.querySelector('.Drawer__Content').innerHTML = tempElement.querySelector('.Drawer__Content').innerHTML;
          $('.customcartcount').html( tempElement.querySelector('.customcartcount').innerHTML);
        }
      });
    });
  });
const elPage = document.querySelectorAll(".lb-swiper-stories-holder");
for (let i = 0; i < elPage.length; i++ ) {
  const centerX = (elPage[i].scrollWidth - elPage[i].clientWidth) / 2;
  const centerY = (elPage[i].scrollHeight - elPage[i].clientHeight) / 2;
  elPage[i].scrollTo(centerX, centerY);
}